/**
 * The login views that belong to a sign-in still under way: the code step and
 * the screens that follow a verified code. A session already exists during all
 * of them, so "signed in" alone cannot mean "finished" -- a new account is
 * signed in the moment its code is accepted, and still owes the more-info step.
 */
export const LOGIN_IN_PROGRESS_VIEWS: readonly string[] = [
	"loggedin",
	"welcome",
	"phone-verified",
	"more-info",
	"login-otp",
];

/** Is the login flow mid-way, judging by the location hash it keeps? */
export function isLoginInProgress(hash: string): boolean {
	return LOGIN_IN_PROGRESS_VIEWS.includes(hash.replace(/^#/, ""));
}
